import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';

export default class OpportunityMeeting extends BaseModel
{
    
    static getPrefix()
    {
        return 'worksite:opportunity-meeting';
    }

    static getEndpoint(opportunity)
    {
        return window.Worksite.endpoints.opportunityMeeting.setOpportunity(opportunity);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.opportunity);
    }

    containsUndefinedUsers()
    {
        return this.getUsersWithUndefined().length > this.getUsers().length;
    }

    getUsersWithUndefined()
    {
        return this.users_id.map(id => {
            return window.App.$store.state.models.users.find(user => user.id == id);
        });
    }

    getUsers()
    {
        return this.getUsersWithUndefined().filter(u => u !== undefined);
    }

    getUsersName()
    {
        return this.getUsers().map(user => user.getDisplayName()).join(', ');
    }

};